// Interface data format used to return a unified format

export function resultSuccess<T = Recordable>(data: T, { message = 'OK' } = {}) {
  // return {
  //   code: 0,
  //   result,
  //   message,
  //   type: 'success',
  //   success:true,
  //   data:result
  // };
  return {
    clientDataId: '',
    data,
    error: null,
    message,
    status: '200',
    success: true,
  };
}

export function resultPageSuccess<T = any>(
  page: number,
  pageSize: number,
  data: T[],
  { message = 'ok' } = {},
) {
  const pageData = pagination(page, pageSize, data);

  return {
    ...resultSuccess({
      data: pageData,
      total: data.length,
    }),
    message,
  };
}

export function resultError(message = 'Request failed', { code = -1, result = null } = {}) {
  return {
    code,
    result,
    message,
    type: 'error',
  };
}

export function pagination<T = any>(pageNo: number, pageSize: number, array: T[]): T[] {
  const offset = (pageNo - 1) * Number(pageSize);
  const ret =
    offset + Number(pageSize) >= array.length
      ? array.slice(offset, array.length)
      : array.slice(offset, offset + Number(pageSize));
  return ret;
}

export interface requestParams {
  method: string;
  body: any;
  headers?: { authorization?: string,'pa-at'?:string };
  query: any;
}

/**
 * @description 本函数用于从request数据中获取token，请根据项目的实际情况修改
 *
 */
export function getRequestToken({ headers }: requestParams): string | undefined {
  return headers?.authorization;
}
